module.exports = __webpack_public_path__ + "img/helpbox-5.c0ad5ecf.png";